import React from 'react';
import './Login.css';
import mainAPI from 'api/MainAPI.js';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import Card from '../../components/card/Card';
import history from '../../history';
import Button from '../../components/button/Button';
import logo from 'components/icon/whiteLogo.svg';
import Input from '../../inputs/input/Input';
import toasts from 'utils/toasts';
import ChooseGroupPopup from '../../popups/chooseGroupPopup/ChooseGroupPopup';
import ForgotPassword from '../../cards/forgotPassword/ForgotPassword';
import Label from '../../components/label/Label';
import EnterDualFactorCodePopup from '../../popups/enterDualFactorCodePopup/EnterDualFactorCodePopup';
import {urls} from "../groupUserListPage/GroupUserListPage";

export default class Login extends FormTemplate {
	constructor(props) {
		super(props);
		this.state = {
			forgotPasswordModal: false
		};
	}

	componentDidMount() {
		window.addEventListener('keyup', (event) => {
			if (event.keyCode !== 13) {
				return;
			}
			this.OnEnterPress();
		});
	}

	componentWillUnmount() {
		window.removeEventListener('keyup', (event) => {
			if (event.keyCode !== 13) {
				return;
			}
			this.OnEnterPress();
		});
	}

	continue = async () => {
		delete localStorage.password_reset_guid;
		delete localStorage.user_group_id;
		let res = await mainAPI.user.login(this.getValue());
		if (res && res.token) {
			onLoginSuccess(res);
		} else if (res && res.dual_factor_guid) {
			return window.popupController.show(EnterDualFactorCodePopup, {dualFactorGuid: res.dual_factor_guid});
			// eslint-disable-next-line no-undef
		} else if (res?.err?.response?.data?.err === 'PASSWORD_RESET_REQUIRED') {
			toasts.show('Password reset required', 3000);
		} else {
			toasts.show('Incorrect email or password');
		}
	};

	_signup = () => {
		history.navigate('/signup');
	};

	openForgotPasswordModal = () => {
		this.setState({forgotPasswordModal: true});
	};

	closeForgotPasswordModal = () => {
		this.setState({forgotPasswordModal: false});
	};

	getAttemptedEmail = () => {
		let attempted = this.getValue();
		return attempted.username;
	};

	OnEnterPress = () => {
		console.log(document.activeElement);
		if (document.activeElement.onClick !== null) {
			document.activeElement.click()
		} else {
			this.continue();
		}
	}

	render() {
		return (
			<div className="g-login" name="login">
				<div className="background">
					<div className="top-background">
						<img src={logo} alt="logo" className="white-logo" />
						<div className={'gradient'}></div>
						<img className={'hero'} alt={'background'} src={'https://logrx.com/assets/optimized/background.webp?v=ad0b2ba031'}/>
					</div>
				</div>
				{this.state.forgotPasswordModal && (
					<ForgotPassword attemptedEmail={this.getAttemptedEmail()} close={this.closeForgotPasswordModal}/>
				)}
				<Card>
					{/*<Navbar title="Log-in" backLink="Back"></Navbar>*/}
					{/*<Label large black center> Log in to LogRx</Label>*/}
					{/*<img src={logo} alt="Company Logo" className={'logo'} />*/}
					<Label large className={'login'}>Admin Login</Label>
					<Input
						loginInput
						ref={(ref) => (this.myRefs.username = ref)}
						center
						placeholder="Email address"
					/>
					<Input
						loginInput
						ref={(ref) => (this.myRefs.password = ref)}
						center
						placeholder="Password"
						type="password"
					/>

					<Button center color="white" bg="blue" onClick={this.continue}>
						Continue
					</Button>
					<Label className={'forgot'}>
						<div tabIndex="0" className="forgot-password" onClick={this.openForgotPasswordModal}>
							Password Reset
						</div>
					</Label>

					{/*<p className="no-account">Don't have an account? <Button onClick={this._signup}>Sign-up</Button></p>*/}
				</Card>
			</div>
		);
	}
}

export const onLoginSuccess = (user) => {
	if (user.role !== 'admin' && user.role !== 'super_admin') {
		toasts.show('You are not an admin. Redirecting to app');
		const storage = {token: user.token, last_log_in: Date.now()};
		if (user.num_additional_groups >= 1) {
			storage.num_additional_groups = user.num_additional_groups;
		} else {
			storage.user_group_id = user.user_group_id;
		}
		setTimeout(() => {
			window.location = urls[window.location.origin] + '?storage=' + encodeURIComponent(JSON.stringify(storage)) + '#set-storage'
		}, 1500);
		return;
	}
	localStorage.token = user.token;
	localStorage.region = user.region;
	localStorage.last_log_in = Date.now();
	const urlParams = new URLSearchParams(window.location.search);
	let returnURL = urlParams.get('return-url');
	if (user.num_additional_groups >= 1) {
		localStorage.num_additional_groups = user.num_additional_groups;
		return window.popupController.show(ChooseGroupPopup, {});
	} else {
		localStorage.user_group_id = user.user_group_id;
		delete localStorage.num_additional_groups;
	}
	if (returnURL) {
		window.location = returnURL;
	} else {
		window.location = '/';
	}
};



// WEBPACK FOOTER //
// ./src/pages/login/Login.jsx